import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/images/Done.png'
import _imports_1 from '@/assets/images/copy.svg'
import _imports_2 from '@/assets/images/printer.svg'
import _imports_3 from '@/assets/images/whatsapp.svg'


const _hoisted_1 = { class: "thank-page container" }
const _hoisted_2 = { class: "row d-flex align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 d-flex justify-content-center align-items-center"
}
const _hoisted_4 = { class: "spinner-container" }
const _hoisted_5 = { class: "mt-3 text-muted" }
const _hoisted_6 = {
  key: 1,
  class: "col-12 d-flex align-items-center flex-column justify-content-center"
}
const _hoisted_7 = {
  key: 0,
  class: "success-text text-capitalized"
}
const _hoisted_8 = {
  key: 1,
  class: "fail-text text-capitalized"
}
const _hoisted_9 = { class: "success_message__content" }
const _hoisted_10 = ["alt"]
const _hoisted_11 = { class: "success_message__description container" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "success_message__actions mb-3" }
const _hoisted_14 = ["alt"]
const _hoisted_15 = ["alt"]
const _hoisted_16 = { class: "corss-sell container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CrossSaleContainer = _resolveComponent("CrossSaleContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[4] || (_cache[4] = _createElementVNode("div", {
                class: "spinner-border text-primary",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ], -1)),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("Loading...") || "Loading..."), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (!_ctx.isPaymentFailed)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.$t("Thank.done")) + " ", 1),
                  _cache[5] || (_cache[5] = _createElementVNode("img", {
                    class: "done-img",
                    src: _imports_0,
                    alt: "done",
                    loading: "lazy"
                  }, null, -1))
                ]))
              : (_openBlock(), _createElementBlock("h2", _hoisted_8, _toDisplayString(_ctx.$t("Thank.PaymentFailed")), 1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("b", null, _toDisplayString(_ctx.$t("Thank.orderNum")), 1),
              _createElementVNode("span", null, [
                _createElementVNode("span", {
                  ref: "orderNumber",
                  style: _normalizeStyle({ userSelect: _ctx.userSelect })
                }, _toDisplayString(_ctx.orderNum), 5),
                (_ctx.thankData.enable_copy_order_number)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      width: "35",
                      height: "35",
                      class: "px-2",
                      src: _imports_1,
                      alt: _ctx.$t('Thank.orderNum'),
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyOrderNumber && _ctx.copyOrderNumber(...args)))
                    }, null, 8, _hoisted_10))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                innerHTML: _ctx.thankData.thank_you_message
              }, null, 8, _hoisted_12)
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.thankData.enable_invoice_printing)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-dark print",
                    "aria-label": "Print",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.printInvoice && _ctx.printInvoice(...args)))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Thank.printInvoice")) + " ", 1),
                    _createElementVNode("img", {
                      width: "24",
                      height: "24",
                      src: _imports_2,
                      alt: _ctx.$t('Thank.printInvoice')
                    }, null, 8, _hoisted_14)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.thankData.redirect_to_whatsapp)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    "aria-label": "Whatsapp",
                    class: "btn btn-success whatsapp",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToWhatsApp && _ctx.redirectToWhatsApp(...args)))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("Thank.contact")) + " ", 1),
                    _createElementVNode("img", {
                      width: "24",
                      height: "24",
                      src: _imports_3,
                      alt: _ctx.$t('Thank.contact')
                    }, null, 8, _hoisted_15)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.thankData.return_to_sales_page_button)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    "aria-label": "GoBack",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToSalesPage && _ctx.goToSalesPage(...args))),
                    class: "btn btn-outline-primary back-product"
                  }, _toDisplayString(_ctx.$t("Thank.returnToProduct")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_CrossSaleContainer, {
                orderID: _ctx.orderID,
                productID: _ctx.productID,
                crossSaleAdded: _ctx.crossSaleAdded
              }, null, 8, ["orderID", "productID", "crossSaleAdded"])
            ])
          ]))
    ])
  ]))
}